import Icon from 'components/Icon'
import React from 'react'
import styled from 'styled-components'
import { colors } from 'utils'

const S = {
    Item: styled.div`
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        height: 56px;
        padding: 0 16px;
        border: 1px solid ${colors.statusBorder};
        box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.1);
        border-radius: 4px;
        cursor: pointer;
        margin-bottom: 8px;
        &:hover .item-name {
            color: ${colors.primary};
        }
        &:hover .right-icon path{
            fill: ${colors.primary} !important;
        }
    `,
    Info: styled.div`
        display: flex;
        flex-direction: column;
        justify-content: center;
        flex-grow: 1;
        overflow: hidden;
    `,
    Name: styled.p`
        margin-bottom: 0;
        font-size: 14px;
        color: ${colors.grayTitle};
    `,
    DateInfo: styled.span`
        font-size: 12px;
        color: ${colors.icon};
    `,
    Icon: styled(Icon)`
        flex-shrink: 0;
    `
}

const Item = ({ name, dateInfo }: { name: string, dateInfo?: string }) => (
    <S.Item>
        <S.Info>
            <S.Name className="item-name text-cut">
                {name}
            </S.Name>
            <S.DateInfo>
                {dateInfo}
            </S.DateInfo>
        </S.Info>
        <Icon className="right-icon" icon="arrowRight" size={20} />
    </S.Item>
)

export default Item
